var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.492 16.94C10.6173 16.94 9.83867 16.716 9.156 16.268C8.484 15.82 7.956 15.1853 7.572 14.364C7.19867 13.5427 7.012 12.572 7.012 11.452C7.012 10.332 7.19867 9.372 7.572 8.572C7.956 7.76133 8.484 7.14266 9.156 6.716C9.83867 6.27866 10.6173 6.06 11.492 6.06C12.3773 6.06 13.156 6.27866 13.828 6.716C14.5 7.14266 15.028 7.76133 15.412 8.572C15.796 9.372 15.988 10.332 15.988 11.452C15.988 12.572 15.796 13.5427 15.412 14.364C15.028 15.1853 14.5 15.82 13.828 16.268C13.156 16.716 12.3773 16.94 11.492 16.94ZM11.492 15.772C12.1213 15.772 12.6653 15.596 13.124 15.244C13.5933 14.8813 13.956 14.38 14.212 13.74C14.468 13.0893 14.596 12.3267 14.596 11.452C14.596 10.1507 14.3133 9.12133 13.748 8.364C13.1827 7.60666 12.4307 7.228 11.492 7.228C10.5533 7.228 9.80133 7.60666 9.236 8.364C8.67067 9.12133 8.388 10.1507 8.388 11.452C8.388 12.3267 8.516 13.0893 8.772 13.74C9.028 14.38 9.39067 14.8813 9.86 15.244C10.3293 15.596 10.8733 15.772 11.492 15.772Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.896 10.876L10.4 12.476H13.552L13.056 10.876C12.864 10.2893 12.6827 9.708 12.512 9.132C12.3413 8.54533 12.1707 7.948 12 7.34H11.936C11.776 7.948 11.6107 8.54533 11.44 9.132C11.2693 9.708 11.088 10.2893 10.896 10.876ZM7.696 16.748L11.248 6.252H12.752L16.304 16.748H14.88L13.888 13.548H10.064L9.056 16.748H7.696Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.336 16.748V6.252H11.456C12.1707 6.252 12.7947 6.33733 13.328 6.508C13.872 6.67867 14.2933 6.95067 14.592 7.324C14.9013 7.69733 15.056 8.19333 15.056 8.812C15.056 9.33467 14.9227 9.80933 14.656 10.236C14.4 10.652 14.0213 10.94 13.52 11.1V11.164C14.1493 11.2813 14.6613 11.548 15.056 11.964C15.4613 12.38 15.664 12.9507 15.664 13.676C15.664 14.3587 15.4933 14.9293 15.152 15.388C14.8213 15.8467 14.3573 16.188 13.76 16.412C13.1627 16.636 12.4693 16.748 11.68 16.748H8.336ZM9.664 10.716H11.216C12.112 10.716 12.7573 10.5613 13.152 10.252C13.5467 9.94267 13.744 9.52133 13.744 8.988C13.744 8.38 13.536 7.948 13.12 7.692C12.7147 7.436 12.1013 7.308 11.28 7.308H9.664V10.716ZM9.664 15.692H11.488C12.3947 15.692 13.0987 15.5267 13.6 15.196C14.1013 14.8547 14.352 14.332 14.352 13.628C14.352 12.9773 14.1013 12.5027 13.6 12.204C13.1093 11.8947 12.4053 11.74 11.488 11.74H9.664V15.692Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsIt);
export default __webpack_public_path__ + "static/media/Spritemedals_it.51024675d907b6890f0310548a538d8e.svg";
export { ForwardRef as ReactComponent };